import { SimpleLayout, DocsLayout, BlogLayout } from "@portaljs/core";
import ShowcaseLayout from "./showcase";
import UnstyledLayout from "./unstyled";
import ArticleLayout from "./article";
import PlaybookLayout from "./playbook";
import BlogPostLayout from "./blogPost";
import FaqLayout from "./faq";


export default {
  simple: SimpleLayout,
  docs: DocsLayout,
  blog: BlogLayout,
  unstyled: UnstyledLayout,
  article: ArticleLayout,
  playbook: PlaybookLayout,
  blogPost: BlogPostLayout,
  faq: FaqLayout,
  showcase: ShowcaseLayout,
};
